import * as React from "react";
import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Container } from "bnb-ui/dist";
import ImagemAcessoNegado from "../../assets/img/acesso-negado.png";
import PageCustom from "../../components/PageCustom";
import { useStyles } from "./styles";

type AcessoNegadoPageProps = {
	logout: () => void;
};
const AcessoNegadoPage: React.FC<AcessoNegadoPageProps> = (props: AcessoNegadoPageProps) => {
	const cabecalho = <div></div>;
	return (
		<Container>
			<PageCustom cabecalho={cabecalho}>
				<img src={ImagemAcessoNegado} style={{ marginLeft:  "5%", marginRight: "auto", display: "block" }} alt="marca" />
				<br />
				<Button
					variant="contained"
					color="secondary"
					type="submit"
					style={{
						backgroundColor: "#F2711C",
						marginLeft: "22%",
						marginRight: "auto",
						display: "block",
					}}
					onClick={props.logout}
				>
					Efetuar Login novamente
				</Button>
			</PageCustom>
		</Container>
	);
};
export default AcessoNegadoPage;
